import { render } from "./VueTable.vue?vue&type=template&id=4a0e8172&ts=true"
import script from "./VueTable.vue?vue&type=script&lang=ts"
export * from "./VueTable.vue?vue&type=script&lang=ts"

import "./VueTable.vue?vue&type=style&index=0&id=4a0e8172&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__